import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    header: {
      title: translate({
        id: 'modal.confirmChangeFromRecurrenceToRegularOrderModal.header.title.bulk',
      }),
    },
    body: {
      description: translate({
        id: 'modal.confirmChangeFromRecurrenceToRegularOrderModal.body.description.bulk',
      }),
    },
    footer: {
      save: translate({ id: 'modal.confirmChangeFromRecurrenceToRegularOrderModal.footer.save' }),
      cancel: translate({
        id: 'modal.confirmChangeFromRecurrenceToRegularOrderModal.footer.cancel',
      }),
    },
  }))

  return api
}
